var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLikeIconFill = function SvgLikeIconFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#09090B",
    d: "M16.133 3.08a5.68 5.68 0 0 1 4.02 1.669c2.257 2.256 2.314 5.993-.372 8.729L12.58 20.68a.82.82 0 0 1-1.16 0l-7.196-7.197-.006-.005c-2.686-2.736-2.628-6.473-.372-8.73a5.68 5.68 0 0 1 7.84-.192l.203.194.002.002.109.11.11-.11.002-.002a5.68 5.68 0 0 1 4.022-1.67"
  })));
};
export default SvgLikeIconFill;